import * as Sentry from "@sentry/nextjs";
import { BrowserOptions } from "@sentry/nextjs";

/**
 * Helper class to initialize Sentry in a Next.js application and
 * configure whatever options the specific application needs.
 *
 * REFERENCE: https://docs.sentry.io/platforms/javascript/guides/nextjs/
 */
class SentryNextJS {
  /**
   * REFERENCE: https://docs.sentry.io/platforms/javascript/guides/nextjs/configuration/options/
   *
   * @param {BrowserOptions} options - Options used to configure Sentry's SDK
   */
  init(options: BrowserOptions) {
    return Sentry.init(options);
  }
}

export default SentryNextJS;
